import React, { Component } from 'react'
import { DropdownItem, DropdownMenu, DropdownToggle, Nav, NavItem, NavLink, 
   } from 'reactstrap'
import PropTypes from 'prop-types'
import { firebase } from '../../config/firebase'
// import { Route, Redirect } from 'react-router-dom'
// import XLSX from 'xlsx'
// import { Dropdown, Icon } from 'semantic-ui-react'
import { AppHeaderDropdown, AppNavbarBrand, AppSidebarToggler } from '@coreui/react'
// import logo from '../../assets/img/brand/logo.svg'
import sygnet from '../../assets/img/brand/sygnet.svg'


const propTypes = {
  children: PropTypes.node,
}

const defaultProps = {}


class DefaultHeader extends Component {

  constructor(props) {
    super(props)

    this.state = {
      iconShiftName: '',
      iconSeasonName: '',
      ShiftName: '',
      SeasonName: '',
      displayName: '',
      email:'',
      // shwmodal:false,
      modal: props.initialModalState,
    }
  }

  async componentDidMount() {
    const displayName = await localStorage.getItem('DISPLAYNAME')
    const email = await localStorage.getItem('email')
    const Admin_status = await localStorage.getItem('ADMINSTATUS')
    const sel_hos = await localStorage.getItem('HOSPITAL')

    this.setState({
      displayName: displayName,
      email: email,
      Admin_status: Admin_status,
      sel_hos:sel_hos,
      exp_select: "select year"
    })

    let IconName = ''
    let IconSeaName = ''
    let d = new Date();
    // getYear will give you the years after 1990 i.e currentYear-1990
    // let year = d.getUTCFullYear()
    // console.log("Current year is: " + year);
    // getMonth gives the month value but months starts from 0 add 1 to get actual month value
    let month = d.getMonth() + 1
    // console.log("Current month is: " + month);
    var season;

    if (month >= 1 && month <= 3) {
      season = "phase 1";
      IconSeaName = 'fa fa-sun-o';
    }
    else if (month >= 4 && month <= 6) {
      season = "phase 2";
      IconSeaName = "fa fa-leaf fa-lg"
    }
    else if (month >= 7 && month <= 9) {
      season = "phase 3";
      IconSeaName = 'fa fa-tint'
    }
    else if (month >= 10 && month <= 12) {
      season = "phase 4";
      IconSeaName = 'fa fa-snowflake-o fa-lg';
    }

    let hour = d.getHours();
    var shift;

    if (hour >= 7 && hour <= 12) {
      shift = "Morning";
      IconName = 'fa fa-coffee'
    }
    else if (hour >= 12 && hour <= 17) {
      shift = "Noon";
      IconName = 'fa fa-bell-o'
    }
    else if (hour >= 17 && hour <= 22) {
      shift = "Night";
      IconName = 'fa fa-moon-o'
    }


    this.setState({
      ShiftName: shift,
      SeasonName: season,
      iconShiftName: IconName,
      iconSeasonName: IconSeaName,
    })
  }

  onSignOut = async () => {
    await localStorage.clear();
    await firebase.auth().signOut()
  }
 
  Forgot_onclk = async () => {
    var email = this.state.email;
    if (email!==''){
      firebase.auth().sendPasswordResetEmail(email).then(function () {
        alert('Password Reset Email Sent!');
      }).catch(function (error) {
        var errorCode = error.code;
        var errorMessage = error.message;
        if (errorCode === 'auth/invalid-email') {
          alert(errorMessage);
        } else if (errorCode === 'auth/user-not-found') {
          alert(errorMessage);
        }
        console.log(error);
      });
    }else{
      alert('Please enter an email address and click Forgot password.')
    }
  }


  render() {
    // eslint-disable-next-line
    const { children, ...attributes } = this.props

    return (
      <React.Fragment>
        <AppSidebarToggler className="d-lg-none" display="md" mobile />
        <AppNavbarBrand
          full={{ src: require('../../assets/img/web_logo01.png'), width: 120, height: 35, alt: 'CoreUI Logo' }}
          minimized={{ src: sygnet, width: 30, height: 30, alt: 'CoreUI Logo' }}
        />
        <AppSidebarToggler className="d-md-down-none" display="lg" />

        <Nav className="d-md-down-none" navbar>
          <NavItem className="px-3">
            <NavLink href="/">Dashboard</NavLink>
          </NavItem>
          <NavItem className="px-3 row align-items-center">
            <i className={`${this.state.iconShiftName} mr-2 text-muted`}></i>
            {/* <i className={this.state.iconShiftName+'mr-2 text-muted'}></i> */}

            <NavLink href="#">{this.state.ShiftName}</NavLink>
          </NavItem>
          <NavItem className="px-3 row align-items-center">
            {/* <i className="fa fa-snowflake-o mr-2 text-muted"></i> */}
            <i className={`${this.state.iconSeasonName} mr-2 text-muted`}></i>
            <NavLink href="#">{this.state.SeasonName}</NavLink>
          </NavItem>
        </Nav>
        <Nav className="ml-auto" navbar>
          <AppHeaderDropdown direction="down">
            <DropdownToggle nav className='text-center mr-2'>
              <i className="menu-icon fa fa-user-circle" aria-hidden="true"></i>
              <span className="dropdown-toggle"> Hello, {this.state.displayName}</span>
            </DropdownToggle>
            <DropdownMenu right style={{ right: 'auto' }}>
              <DropdownItem header tag="div" className="text-center"><strong>Account</strong></DropdownItem>
              <DropdownItem ><i className="fa fa-user"></i> Manage Account</DropdownItem>
              <DropdownItem onClick={this.Forgot_onclk}><i className="fa fa-wrench"></i> Change Password</DropdownItem>
              <DropdownItem onClick={this.onSignOut}><i className="fa fa-sign-out"></i> Sign Out</DropdownItem>
            </DropdownMenu>
          </AppHeaderDropdown>
        </Nav>

      </React.Fragment>
    )
  }
}

DefaultHeader.propTypes = propTypes
DefaultHeader.defaultProps = defaultProps

export default DefaultHeader



// WEBPACK FOOTER //
// ./src/containers/DefaultLayout/DefaultHeader.js